(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/dom', ['exports'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.dom = {})));
}(this, (function (exports) { 'use strict';

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var hasNativeClosest = typeof Element !== 'undefined' && !!Element.prototype.closest;
    /** IE 11 compatible closest implementation that is able to start from non-Element Nodes. */
    function closest(element, selector) {
        if (!(element instanceof Node)) {
            return null;
        }
        var curr = element;
        while (curr != null && !(curr instanceof Element)) {
            curr = curr.parentNode;
        }
        return curr && (hasNativeClosest ?
            curr.closest(selector) : polyfillClosest(curr, selector));
    }
    /** Polyfill for browsers without Element.closest. */
    function polyfillClosest(element, selector) {
        var curr = element;
        while (curr != null && !(curr instanceof Element && matches(curr, selector))) {
            curr = curr.parentNode;
        }
        return (curr || null);
    }
    /** IE 11 compatible matches implementation. */
    function matches(element, selector) {
        return element.matches ?
            element.matches(selector) :
            element['msMatchesSelector'](selector);
    }

    /**
     * Generated bundle index. Do not edit.
     */

    exports.closest = closest;
    exports.matches = matches;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-dom.umd.js.map
